import { Component, OnInit, Inject, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';
import { UserConstant } from 'src/app/shared/constants/user-constant';
import { ApService } from 'src/app/shared/services/ap.service';
import { forkJoin, Subscription } from 'rxjs';
import { TemplateService } from 'src/app/shared/services/template.service';

@Component({
  selector: 'app-edit-organization',
  templateUrl: './edit-organization.component.html',
  styleUrls: ['./edit-organization.component.scss']
})
export class EditOrganizationComponent implements OnInit, OnDestroy {
  orgForm: FormGroup;
  submitted = false;
  device = [];
  monitors = [];
  wnetworks = [];
  qosList = [];
  teamList = [];
  i4glteList = [];
  tprofileList = [];
  orgDialogData: any;
  rootOrganization: any;
  orgId: any;
  user: any;
  domain: any;
  role: any;
  isRootUser: boolean;
  bPending: boolean = false;
  isMaster: boolean = false;
  pendingList = [];
  filteredOrg = [];
  searchPipe: any;
  searchOrgPipe: any;

  orgType = [{
    name: "Master MSP",
    id: 1
  },
  {
    name: "MSP",
    id: 2
  },
  {
    name: "Organization",
    id: 3
  }]

  selectedRole: any;
  allowAllLoginSources = true;
  loginAclEnabled = false;
  canSetLoginAcl = false;

  @ViewChild('macinput') searchMacElement: ElementRef;
  @ViewChild('orginput') searchOrgElement: ElementRef;

  private loadDataSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    public userService: UserService,
    public apService: ApService,
    private toastr: ToastrService,
    private router: Router,
    private templateService: TemplateService,
    public dialogRef: MatDialogRef<EditOrganizationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    let storedUser = JSON.parse(localStorage.getItem(UserConstant.USER));
    this.isRootUser = storedUser.role == 0;
    this.user = storedUser;

    this.domain = this.data.domain;

    this.orgForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      domain: new FormControl('', [Validators.required]),
      parent: new FormControl(null, []),
      role: new FormControl('', [Validators.required]),
      pendings: new FormControl([]),
      loginAclEnabled: new FormControl(false),
      loginAclAllowedCidrs: new FormControl('', [this.loginAclCidrsValidator.bind(this)]),
      loginAclDeniedCidrs: new FormControl('', [this.loginAclCidrsValidator.bind(this)])
    });

    if (this.data && this.data._id) {
      this.setEditOrganization(this.data);
      this.userService.getOrganization({ id: this.data._id }).subscribe(res => {
        this.setEditOrganization(this.getOrganizationFromResponse(res));
      })
    }

    this.loadDataSubscription = this.userService.getOrganization({ id: this.user.organization }).subscribe(res => {
      res = res.data[0];
      if (res) {
        this.rootOrganization = res;
        this.canSetLoginAcl = this.isMspAdminOrAbove(this.user.role, res.role);
        this.setFilteredOrganizations(res);
      }
    });
  }

  setEditOrganization(org) {
    if (!org) {
      return;
    }

    this.orgDialogData = org;
    this.orgId = org._id;
    this.role = org.role;
    this.orgForm.controls.name.setValue(org.name);
    this.orgForm.controls.domain.setValue(org.domain);
    this.orgForm.controls.parent.setValue(org.parentOrganization);
    this.orgForm.controls.role.setValue(org.role);
    this.applyLoginAcl(org);
    this.setFilteredOrganizations(this.rootOrganization);
  }

  getOrganizationFromResponse(res) {
    if (!res) {
      return null;
    }

    if (Array.isArray(res.data)) {
      return res.data[0];
    }

    return res.data || res;
  }

  setFilteredOrganizations(rootOrg) {
    if (!rootOrg || !this.orgDialogData) {
      return;
    }

    let filterOrg = this.getDomainOrg(rootOrg);
    this.filteredOrg = filterOrg.filter(o => o.role <= (this.orgDialogData.role - 1) && o._id !== this.orgId)
  }

  getDomainOrg(domain) {
    let filtered = [];
    filtered.push(domain)
    for (let i = 0; i < domain.subOrganizations.length; i++) {
      let org = domain.subOrganizations[i];
      filtered = [...filtered, ...this.getDomainOrg(org)]
    }
    return filtered;
  }

  applyLoginAcl(org) {
    const loginAcl = org.loginAcl || org.login_acl || {};
    const allowedCidrs = loginAcl.allowedCidrs || loginAcl.allowed_cidrs || loginAcl.sourceIps || org.loginAclSourceIps || org.allowedLoginSourceIps || [];
    const deniedCidrs = loginAcl.deniedCidrs || loginAcl.denied_cidrs || org.loginAclDeniedCidrs || [];
    const allowedEntries = Array.isArray(allowedCidrs) ? allowedCidrs : this.normalizeLoginAclCidrs(allowedCidrs);
    const deniedEntries = Array.isArray(deniedCidrs) ? deniedCidrs : this.normalizeLoginAclCidrs(deniedCidrs);
    const enabled = loginAcl.enabled === true || org.loginAclEnabled === true || allowedEntries.length > 0 || deniedEntries.length > 0;

    this.allowAllLoginSources = !enabled;
    this.loginAclEnabled = enabled;
    this.orgForm.controls.loginAclEnabled.setValue(enabled);
    this.orgForm.controls.loginAclAllowedCidrs.setValue(allowedEntries.join('\n'));
    this.orgForm.controls.loginAclDeniedCidrs.setValue(deniedEntries.join('\n'));
  }

  isMspAdminOrAbove(userRole, orgRole) {
    const normalizedUserRole = Number(userRole);
    const normalizedOrgRole = Number(orgRole);

    if (!Number.isFinite(normalizedUserRole)) {
      return false;
    }

    if (Number.isFinite(normalizedOrgRole)) {
      return normalizedOrgRole <= 2 && normalizedUserRole <= 2;
    }

    return normalizedUserRole <= 2;
  }

  normalizeLoginAclCidrs(value) {
    if (!value) {
      return [];
    }
    return value.split(/[\n,]+/)
      .map(ip => ip.trim())
      .filter(ip => ip.length);
  }

  isValidLoginAclCidr(value) {
    const parts = value.split('/');
    if (parts.length > 2) {
      return false;
    }

    if (parts.length === 2) {
      const prefix = Number(parts[1]);
      if (!Number.isInteger(prefix) || prefix < 0 || prefix > 32) {
        return false;
      }
    }

    const octets = parts[0].split('.');
    if (octets.length !== 4) {
      return false;
    }

    return octets.every(octet => {
      if (!/^\d{1,3}$/.test(octet)) {
        return false;
      }
      const value = Number(octet);
      return value >= 0 && value <= 255;
    });
  }

  loginAclCidrsValidator(control: FormControl) {
    const entries = this.normalizeLoginAclCidrs(control.value);
    if (!entries.length) {
      return null;
    }
    return entries.every(entry => this.isValidLoginAclCidr(entry)) ? null : { loginAclCidrs: true };
  }

  onAllowAllLoginSourcesChange(event) {
    this.allowAllLoginSources = event.checked;
    this.loginAclEnabled = !event.checked;
    this.orgForm.controls.loginAclEnabled.setValue(this.loginAclEnabled);

    if (event.checked) {
      this.orgForm.controls.loginAclAllowedCidrs.setValue('');
      this.orgForm.controls.loginAclDeniedCidrs.setValue('');
    }
  }

  onLoginAclCidrsInput() {
    const allowedCidrs = this.normalizeLoginAclCidrs(this.orgForm.get('loginAclAllowedCidrs').value);
    const deniedCidrs = this.normalizeLoginAclCidrs(this.orgForm.get('loginAclDeniedCidrs').value);

    if (allowedCidrs.length || deniedCidrs.length) {
      this.allowAllLoginSources = false;
      this.loginAclEnabled = true;
      this.orgForm.controls.loginAclEnabled.setValue(true);
    }
  }

  getLoginAclPayload() {
    const enabled = !this.allowAllLoginSources;
    const allowedCidrs = this.normalizeLoginAclCidrs(this.orgForm.get('loginAclAllowedCidrs').value);
    const deniedCidrs = this.normalizeLoginAclCidrs(this.orgForm.get('loginAclDeniedCidrs').value);

    if (enabled && !allowedCidrs.length && !deniedCidrs.length) {
      this.toastr.warning('Add at least one allowed or denied login CIDR.');
      return null;
    }

    return {
      enabled,
      allowedCidrs,
      deniedCidrs
    };
  }

  saveLoginAcl(orgId, onSuccess) {
    if (!this.canSetLoginAcl) {
      onSuccess();
      return;
    }

    const loginAcl = this.getLoginAclPayload();
    if (!loginAcl) {
      this.submitted = false;
      return;
    }

    this.userService.setOrganizationLoginAcl(orgId, loginAcl).subscribe(res => {
      onSuccess();
    }, (error => {
      this.submitted = false;
      this.toastr.error(error.error.error);
    }));
  }

  searchMacFocus() {
    setTimeout(() => {
      this.searchMacElement.nativeElement.focus();
    }, 50);
  }

  searchOrgFocus() {
    setTimeout(() => {
      this.searchOrgElement.nativeElement.focus();
    }, 50);
  }

  onSubmit() {
    if (this.submitted) return;
    // stop here if form is invalid
    if (this.orgForm.invalid) {
      return;
    } else {
      let name = this.orgForm.get('name').value;
      let domain = this.orgForm.get('domain').value;
      let parent = this.orgForm.get('parent').value;
      let role = this.orgForm.get('role').value;
      let pendings = this.bPending ? this.orgForm.get('pendings').value : [];
      const postObject = {
        name: name,
        domain: domain,
        parentOrg: parent,
        role: role,
      };

      if (this.orgId) {
        postObject['_id'] = this.orgId;
      }
      if (this.orgId && pendings.length) {
        const oject = {
          mac: pendings,
          orgId: this.orgId,
          type: 'pending',
          domain: name
        }
        this.submitted = true;
        forkJoin([
          this.apService.movePendingDevices(oject),
          this.userService.createOrganization(postObject)
        ]).subscribe(results => {
          this.saveLoginAcl(this.orgId, () => {
            this.submitted = false;
            this.dialogRef.close();
          });
        }, (err => {
          this.submitted = false;
          this.toastr.error(err.error.error);
        }))
      } else {
        this.submitted = true;
        this.userService.createOrganization(postObject).subscribe(res => {
          this.saveLoginAcl(this.orgId, () => {
            this.submitted = false;
            this.toastr.success(' Organization Changed Successfully!');
            this.dialogRef.close();
          });
        }, (error => {
          this.submitted = false;
          this.toastr.error(error.error.error);
        }));
      }

    }
  }

  loadData() {
    if (this.bPending && this.pendingList.length == 0) {
      this.loadDataSubscription = this.apService.getPendingDevice({}).subscribe(res => {
        this.pendingList = res.data;
        let pendings = this.pendingList.filter(d => d.orgId == this.orgId).map(d => d.mac)
        this.orgForm.controls.pendings.setValue(pendings);
      })
    }
  }

  onDomainChange(e) {
    let org = this.filteredOrg.find(o => o._id == e.value)
    this.role = org.role

    if(this.role != 3){
      if(this.role == 2){
        this.selectedRole = 3;
      } else if(this.role == 1){
        this.selectedRole = 2;
      } else if(this.role == 0){
        this.selectedRole = 1;
      }
    }

    if (!org) {
      return;
    }
    this.templateService.getPrtgForOrganization(org.orgId).subscribe(res => {
      this.monitors = res;
    })
    this.templateService.getWnetworkforOrg(org.orgId).subscribe(res => {
      this.wnetworks = res;
    })
    this.templateService.getQosForOrg(org.orgId).subscribe(res => {
      this.qosList = res;
    })
    this.templateService.getI4glteForOrg(org.orgId).subscribe(res => {
      this.i4glteList = res;
    })
    this.templateService.getTeamForOrg(org.orgId).subscribe(res => {
      this.teamList = res;
    })
    this.templateService.getTprofileForOrg(org.orgId).subscribe(res => {
      this.tprofileList = res;
    })
  }

  ngOnDestroy(): void {
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
  }
}
